import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngxs/store';
import {Labour} from '../../models/labour/labour.model';
import {LabourState} from '../../state/labour.state';

@Pipe({
  standalone: false,
  name: 'labour'
})
export class LabourResolvePipe implements PipeTransform {
  private readonly labours: Labour[];

  constructor(private store: Store) {
    this.labours = this.store.selectSnapshot(LabourState.labours);
  }

  transform(value: any): string {
    if (value === null || value === undefined || value === '' || this.labours?.length === 0) {
      return null;
    }
    const labour = this.labours.find(c => c.id === value);
    if (labour) {
      return labour.name;
    }
    return null;
  }

}
